import { BaseRepository } from "../api/BaseRepository";
import * as SendMessageAction from "@mywvglobal-shared/mywv-shared/action/sendMessageAction";
import * as ConnectFeedAction from "@mywvglobal-shared/mywv-shared/action/connectFeedAction";
import * as UpdatePhotoGuidelineAction from "@mywvglobal-shared/mywv-shared/action/updatePhotoGuidelineViewedStatusAction";
import * as UserDetailsAction from "@mywvglobal-shared/mywv-shared/action/userDetailsAction";
import * as SponsorshipsAction from "@mywvglobal-shared/mywv-shared/action/sponsorshipsDataAction";
import * as DeleteDraftAction from "@mywvglobal-shared/mywv-shared/action/deleteDraftAction";
import * as DraftDetailsAction from "@mywvglobal-shared/mywv-shared/action/draftDetailsAction";
import * as GetTemplatesAction from "@mywvglobal-shared/mywv-shared/action/getWritingTemplatesAction";
import * as SaveDraftAction from "@mywvglobal-shared/mywv-shared/action/saveDraftAction";
// import {getFieldDropDays} from "../utilities/fieldDropEligibilityUtils.js";

export class ConnectRepository extends BaseRepository {
  /**
   * Sends a message from a sponsor to a child.
   */
  async sendMessage(requestBase, selectedBorder, isDefaultBorderVisible, letterWritingLanguageCode, languageCode) {
    if (!this.baseURL) return;

    let artifactID = 0;
    if (selectedBorder && isDefaultBorderVisible) {
      artifactID = selectedBorder.artifactID;
    }

    this.dispatch(SendMessageAction.clearSendAMessageFeedReducer());
    this.dispatch(SendMessageAction.showSendAMessageReducer());

    const reqBody = {
      sponsorID: requestBase?.sponsorID,
      childCode: requestBase?.childCode,
      childName: requestBase?.childName, 
      subject: requestBase?.messageSubject,
      messageBody: requestBase?.messageBody,
      base64Image: requestBase?.imageBase64 ? requestBase?.imageBase64 : null,
      artifactID,
      letterWritingLanguageCode: letterWritingLanguageCode,
      languageCode: languageCode,
    };

    const requestPayload = { baseURL: this.baseURL, reqBody, reqHeaders: await this.getHeaders() };
    this.dispatch(SendMessageAction.sendAMessageRequest(requestPayload));
  }


  /**
   * Retrieves connect feed data.
   */
  async getConnectFeed(persistItemsReducer, loginReducer, props, params) {
    this.dispatch(ConnectFeedAction.showConnectFeedReducer());
    const reqBody = {
      sponsorID: persistItemsReducer?.sponsorID,
      childCode: props?.childData ? props?.childData?.childCode : params?.childcode,
      languageCode:
        persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
    };
    const baseURL = loginReducer?.getSOConfiguration?.soBaseUrl;
    const requestPayload = {
      baseURL: loginReducer?.getSOConfiguration?.soBaseUrl,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    // dispatch action in redux call
    if (baseURL) {
      this.dispatch(ConnectFeedAction.getConnectFeedRequest(requestPayload));
    }
  }

  /**
   * Retrieves connect FAQ data.
   */
  async getConnectFAQ(replaceValuesFormatted) {
    if (!this.baseURL) return;

    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      languageCode: this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
      placeHolders: this.loginReducer?.getSOConfiguration?.faqFormatter?.placeHolders,
      replaceValues: replaceValuesFormatted,
    };

    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };

    this.dispatch(ConnectFeedAction.getConnectFAQRequest(requestPayload));
  }

  /**
   * Updates the photo guideline viewed status for the user.
   */
  async updatePhotoGuidelineViewedStatus() {
    if (!this.baseURL) return;

    this.dispatch(UserDetailsAction.clearUserDetailsReducer());
    this.dispatch(UserDetailsAction.showUserDetailsReducer());

    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      isPopUpViewed: true,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(UpdatePhotoGuidelineAction.updatePhotoGuidelineViewedStatusRequest(requestPayload));
  }

  /**
   * Fetches writing templates.
   * @param {string} code - The language code.
   * @param {boolean} isLanguageChange - Whether this is due to a language change.
   */
  async getWritingTemplates(code, isLanguageChange = false) {
    if (!this.baseURL) return;

    this.dispatch(GetTemplatesAction.clearWritingTemplatesReducer());
    this.dispatch(GetTemplatesAction.showWritingTemplatesReducer());
    this.dispatch(GetTemplatesAction.hideWritingTemplatesReducer());

    const reqBody = {
      sponsorID: this.persistItemsReducer?.sponsorID,
      languageCode: isLanguageChange
        ? code
        : this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
    };
    const requestPayload = { baseURL: this.baseURL, reqBody, reqHeaders: await this.getHeaders() };

    this.dispatch(GetTemplatesAction.getWritingTemplatesRequest(requestPayload));
  }

  /**
   * Fetches sponsorships data for the current donor.
   */
  async getSponsorshipsData() {
    if (!this.baseURL) return;
    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      emailID: this.persistItemsReducer?.emailID,
      languageCode: this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
      // fdNumberofDays: this.loginReducer?.getSOConfiguration?.fdNumberofDays || getFieldDropDays(this.persistItemsReducer?.selectedSOData?.soCode),
      pastSponsoredChildDisplayDuration: this.loginReducer?.getSOConfiguration?.pastSponsoredChildDisplayDuration
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(SponsorshipsAction.getSponsorshipsDataRequest(requestPayload));
  }

  /**
   * Deletes a draft message for the current user.
   */
  async deleteDraft() {
    if (!this.baseURL) return;

    this.dispatch(DeleteDraftAction.showDeleteDraftReducer());
    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      languageCode: this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    // dispatch action in redux call
    this.dispatch(DeleteDraftAction.getDeleteDraftRequest(requestPayload));
  }

  /**
   * Checks for and retrieves available draft messages for the current user.
   */
  async getDraftDetails() {
    if (!this.baseURL) return;

    this.dispatch(DraftDetailsAction.showDraftDetailsReducer());
    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      languageCode: this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(DraftDetailsAction.getDraftDetailsRequest(requestPayload));
  }

  /**
   * Saves a draft message.
   * @param {object} draftData - The data for the draft.
   * @param {string} draftData.messageBody - The body of the message.
   * @param {string[]} draftData.childCode - Array of child codes for recipients.
   * @param {number} draftData.occationCode - The template/occasion ID.
   * @param {number} draftData.bibleVerseCode - The Bible verse ID.
   * @param {string} draftData.imageBase64 - The base64 encoded image.
   * @param {string} draftData.letterWritingLanguageCode - The language code for the letter.
   */
  async saveDraft(draftData) {
    if (!this.baseURL) return;

    this.dispatch(SaveDraftAction.showSaveDraftReducer());
    const reqBody = {
      donorID: this.persistItemsReducer?.sponsorID,
      subject: draftData.subject || " ",
      body: draftData.messageBody || " ",
      childCode: draftData.childCode,
      messageTemplateId: draftData.occationCode || 0,
      bibleVerseId: draftData.bibleVerseCode || 0,
      base64Image: draftData.imageBase64,
      languageCode: this.persistItemsReducer?.selectedSOData?.soLanguageCultureCode,
      letterWritingLanguageCode: draftData.letterWritingLanguageCode || "",
    };
    const requestPayload = {
      baseURL: this.baseURL,
      reqBody,
      reqHeaders: await this.getHeaders(),
    };
    this.dispatch(SaveDraftAction.saveDraftRequest(requestPayload));
  }
}
